import React, { Component, Fragment } from 'react';
import WaveSurfer from 'wavesurfer.js'
import i18n from '../../../i18n'
import { connect } from 'react-redux';
import './EditVideoMusicDialog.scss';
import axios from 'axios'

import Slider from './VideoSlider'
import 'react-image-crop/lib/ReactCrop.scss';
import Dialog from '@material-ui/core/Dialog';
import VMButton from '../../../Common/VMButton';
import 'react-input-range/lib/css/index.css';
import {fabric} from 'fabric';

import Uploading from '@/Common/Uploading/Uploading'

const SMOOTH_DURATION = 1 // 1초

class EditVideoMusicDialog extends Component {
    state = {
        crop: {},
        isFixAspect: true,
        cropDuration: 0, // 음악 길이(s)
        curMusicTime: 0, // (s)
        videoStartTime: 0, // 영상 시작 시간 (ms)
        desDuration: 0, // 영상 길이(s)
        
        // VideoSlider의 외부 조작을 통해 Handle Value를 바꾸는 경우 true로 넘겨줘야하며 그외에 경우엔 false
        isManualValueChange: false,

        isReadyVideo: false,
        isReadyAudio: false,

        videoObjectURL: null,
        audioObjectURL: null,

        isPause: false,

        volume: 100
    };

    videoRef;
    audioRef;

    readyWavesurferId

    intervalId;
    smoothVolumeIntervalId;    
    orgScale;

    canvas;
    videoImg;

    componentDidMount = async () => {
        const { 
            cropDuration, // 음악 길이
            cropDesDuration, // 비디오 길이
            src, // 음악 소스 (URL) 
            cropDes, // 비디오 소스 (URL)
            cashedMediaInfoMap,
            handleChangeCashedMediaInfoMap,
            waveformRef
        } = this.props
        const newState = {}
        const newCashedMediaInfoMap = { ...cashedMediaInfoMap }

        if (cropDuration) newState.cropDuration = cropDuration
        if (cropDesDuration) newState.desDuration = cropDesDuration

        try {
            let mediaInfoMap = {
                [src]: { url: src, type: `audio`, data: null },
                [cropDes]: { url: cropDes, type: `video`, data: null }
            }

            let promises = []

            // 캐시 되어 있는지 확인
            Object.keys(mediaInfoMap).forEach(key => {
                const curData = mediaInfoMap[key]
                const splits = curData.url.split(`/`)
                const fileName = splits[splits.length - 1]
                if(newCashedMediaInfoMap.hasOwnProperty(fileName)) {
                    // 이전에 받은 데이터
                    curData.data = newCashedMediaInfoMap[fileName].data
                }
                else {
                    // 처음 받는 데이터는 get 등록
                    promises.push(axios.get(curData.url, { responseType: 'blob' }))
                }
            })

            // 캐시되지 않은 데이터 요청
            const results = await Promise.all(promises)
            results.forEach(r => {
                const url = r.request.responseURL
                const type = mediaInfoMap[url].type
                const data = URL.createObjectURL(r.data)
                const splits = r.request.responseURL.split(`/`)
                const fileName = splits[splits.length - 1]
                mediaInfoMap[r.request.responseURL].data = data
                newCashedMediaInfoMap[fileName] = { url, type, data }
            })

            // 원본 캐시맵을 바꿔준다.
            handleChangeCashedMediaInfoMap(newCashedMediaInfoMap)
    
            this.readyWavesurferId = setInterval(() => {
                // 부모 컴포넌트에서 isReadyWavesurfer를 true로 넘겨줄때까지 대기
                const element =  document.getElementsByClassName("dialog-audio-wave-container")
                if(element && element[0]) {
                    element[0].appendChild(waveformRef)
                    clearInterval(this.readyWavesurferId)
                    this.forceUpdate()
                }
            }, 100)

            this.setState({ 
                ...newState, 
                curMusicTime: 0, // (s)

                audioObjectURL: mediaInfoMap[src].data,
                videoObjectURL: mediaInfoMap[cropDes].data,
            });
        }
        catch(e) {
            console.log(e)
        }
    }

    componentDidUpdate = () => {
        //this.DisposeCanvas();

        if (!this.canvas && this.state.vWidth) {
            this.canvas = new fabric.Canvas('c', { backgroundColor: 'rgb(75,75,75)', selection: false })
            var video = document.getElementById('v')

            // 비디오를 출력할 이미지 생성
            this.videoImg = new fabric.Image(video, {
                left: 200,
                top: -200,
                width: this.state.vWidth,
                height: this.state.vHeight,
                objectCaching: false,
                fill: 'red',
                originX: 'center',
                originY: 'center',
                selectable: false,
                hoverCursor: 'default'
            })

            // 캔버스 크기에 비례한 비디오 이미지 사이즈 계산
            var sizeX = this.canvas.width / this.videoImg.width
            var sizeY = this.canvas.height / this.videoImg.height

            if (sizeX < sizeY)
                sizeY = sizeX
            else
                sizeX = sizeY

            this.videoImg.scaleX = sizeX
            this.videoImg.scaleY = sizeY

            this.canvas.centerObject(this.videoImg)
            this.canvas.add(this.videoImg)

            fabric.util.requestAnimFrame(this.videoRender)
        }
    }

    componentWillUnmount = () => {
        if(this.smoothVolumeIntervalId) {
            clearInterval(this.smoothVolumeIntervalId);
            this.smoothVolumeIntervalId = null
        }
        clearInterval(this.intervalId);
        this.DisposeCanvas();
    }
    
    SmoothVolumeUpDown = () => {
        const { videoStartTime, desDuration, volume } = this.state

        var audio = document.getElementById('a')
        if(!audio) {
            clearInterval(this.smoothVolumeIntervalId)
            return
        }

        // 영상 시작 / 영상 끝
        var curTime = audio.currentTime - (videoStartTime / 1000)
        var duration = desDuration
        
        // 노래 시작 / 노래 끝
        //var curTime = audio.currentTime
        //var duration = audio.duration
        
        // * 주의사항
        // SMOOTH_DURATION이 duration보다 짧은 경우는 처리하지 않았으니 필요하면 다로 처리해줘야함.
        // 현재 상태로는 SMOOTH_DURATION x 2 > duration인 경우에만 정상적으로 처리됨.
        if(curTime <= 0 || curTime > duration) {
            audio.volume = 0
        }
        else if(curTime <= SMOOTH_DURATION) {
            // 볼륨 업
            audio.volume = Math.max(0, Math.min(1, curTime / SMOOTH_DURATION)) * (volume / 100)
        }
        else if(curTime >= duration - SMOOTH_DURATION) {
            // 볼륨 다운
            audio.volume = Math.max(0, Math.min(1, (duration - curTime) / SMOOTH_DURATION)) * (volume / 100)
        }
        else audio.volume = volume / 100
    }


    DisposeCanvas = () => {
        if (this.canvas) {
            this.canvas.clear();
            this.canvas = null;
        }
    }

    videoRender = () => {
        if (this.canvas) {
            this.canvas.renderAll();
            fabric.util.requestAnimFrame(this.videoRender);
        }
    }

    onCropComplete = async () => {
        const { src, srcInfo, cropComplete, closeDialog } = this.props
        const { videoStartTime, volume } = this.state

        cropComplete(srcInfo, srcInfo.isCustom, SMOOTH_DURATION, Math.max(0, videoStartTime / 1000), volume / 100, src)
        closeDialog();
    }

    checkFrameInRange = () => {
        const { desDuration, cropDuration, videoStartTime } = this.state
        try {
            const curMusicTime = this.audioRef.currentTime;
            const current = curMusicTime - (videoStartTime / 1000)

            // 비디오 재생시간이 초과한 경우 
            if(current >= desDuration || current >= cropDuration)
            {
                // 다시 재생 (처음부터 루프)
                this.playAll()
            }

            this.setState({ curMusicTime })
        } catch (e) {
            clearInterval(this.intervalId);
        }
    }

    playAll = (isPause = false, restart = true) => {
        const { isReadyVideo, isReadyAudio, videoStartTime, 
            desDuration, // 비디오 길이
            cropDuration // 음악 길이
        } = this.state
        if(isReadyVideo && isReadyAudio) {
            if(restart) {
                this.videoRef.currentTime = 0
                const videoStartTimeSeconds = (videoStartTime / 1000)
                this.audioRef.currentTime = videoStartTimeSeconds
            }

            if(isPause) {
                this.videoRef.pause()
                this.audioRef.pause()
            }
            else {
                this.videoRef.play()
                this.audioRef.play()
            }
        }
    }

    handleKeyPress = (e) => {
        if(e.key === "ArrowLeft") {
            this.handleClickLeftFrameBtn()
        }
        else if(e.key === "ArrowRight") {
            this.handleClickRightFrameBtn()
        }
    }

    handleClickPlayAndPauseBtn = () => {
        const isPause = !this.state.isPause
        this.setState({ isPause })
        this.playAll(isPause, false)
    }

    handleClickStopBtn = () => {
        this.setState({ isPause: true })
        this.playAll(true, true)
    }

    handleClickLeftFrameBtn = () => {
        let { videoStartTime } = this.state
        videoStartTime = Math.max(0, (videoStartTime - 100))
        const curMusicTime = videoStartTime / 1000

        this.setState({ videoStartTime, curMusicTime, isManualValueChange: true }, () => {
            this.playAll(this.state.isPause, true)
        })
    }

    handleClickRightFrameBtn = () => {
        const { cropDuration, desDuration } = this.state
        let { videoStartTime } = this.state
        videoStartTime = Math.min((cropDuration - desDuration) * 1000, (videoStartTime + 100))
        const curMusicTime = videoStartTime / 1000
        
        this.setState({ videoStartTime, curMusicTime, isManualValueChange: true }, () => {
            this.playAll(this.state.isPause, true)
        })
    }

    handleChangeCropValue = (value) => {
        const { desDuration, cropDuration } = this.state

        if (value.min < 0 || value.max > cropDuration * 1000) return;

        const duration = Math.abs(value.min - value.max);
        if (Math.abs(duration - Math.floor(desDuration * 1000)) < 2) {
            this.setState({ videoStartTime: value.min, isManualValueChange: false, isPause: false }, () => {
                this.playAll(false, true)
            })
        }
    }

    handleChangeVolume = e => {
        this.setState({ volume: Number(e.target.value) })
    }

    handleClickVolumnOnOff = e => {
        this.setState({ volume: 0 })
    }

    renderCropper = () => {
        const { 
            cropDuration, 
            desDuration, 
            curMusicTime, 
            vWidth, 
            vHeight,
            videoStartTime,
            isManualValueChange,
            audioObjectURL,
            videoObjectURL,
            volume,

            isReadyVideo,
            isReadyAudio
        } = this.state
        const { src, srcInfo } = this.props

        return (
            <Fragment>
                <canvas id='c' width={600} height={375.5}></canvas>
                <video 
                    ref={ref => { this.videoRef = ref }}
                    src={videoObjectURL} 
                    id='v'
                    style={{ display: 'none' }}
                    width={vWidth}
                    height={vHeight}
                    controls muted
                    onCanPlay={(e) => {
                        if (!isReadyVideo) {
                            const duration = desDuration || e.target.duration
                            this.setState({ 
                                isReadyVideo: true,
                                desDuration: duration, 
                                cropValue: { min: 0, max: duration * 1000 },
                                vWidth: e.target.videoWidth, 
                                vHeight: e.target.videoHeight 
                            }, () => {
                                this.playAll()
                            });
                        }
                    }}
                    onPlaying={() => {
                        if(this.smoothVolumeIntervalId) clearInterval(this.smoothVolumeIntervalId);
                        this.smoothVolumeIntervalId = setInterval(this.SmoothVolumeUpDown, 11)

                        clearInterval(this.intervalId);
                        this.intervalId = setInterval(this.checkFrameInRange, 33);
                    }}
                />
                <audio 
                    ref={ref => { this.audioRef = ref; }}
                    src={audioObjectURL}
                    id='a'
                    style={{ display: 'none' }}
                    onCanPlay={(e) => {
                        if (!isReadyAudio) {
                            const duration = cropDuration || e.target.duration
                            this.setState({ 
                                isReadyAudio: true,
                                cropDuration: duration
                            }, () => {
                                this.playAll()
                            })
                        }
                    }}
                >
                    <source src={src} type="audio/m4a" />
                    <source src={src} type="audio/mp3" />
                    <source src={src} type="audio/wave" />
                </audio>
                <br />

                <p className="dialog-subtitle">
                    <div>{i18n.t("makevideo.editvideomusic.subtitle")}</div>
                </p>

                <p className="dialog-message">{i18n.t("makevideo.editvideomusic.message")}</p>

                {/* 노래 제목 */}
                <div className="dialog-music-name-container ">
                    <div className="dialog-music-name">♬ {srcInfo.name.split('.')[0]}</div>
                    <div className="dialog-volumn-container">
                        <img onClick={this.handleClickVolumnOnOff} src={volume > 0 ? "https://front.videomonster.com/images-u6yd72dy/web/musicSoundOffBtn.svg" : "https://front.videomonster.com/images-u6yd72dy/web/musicSoundOnBtn.svg"} alt={"icon-music-sound"} />
                        <input type="range" min={0} max={100} step={5} value={volume} onChange={this.handleChangeVolume} />
                    </div>
                </div>

                <div className="dialog-slider-container">
                    <div className="dialog-audio-wave-container" />
                    <Slider
                        onChangeTime={this.handleChangeCropValue}
                        length={desDuration} // 비디오 총 길이
                        max={cropDuration} // 음악 총 길이
                        indicatorValue={curMusicTime}
                        videoStartTime={videoStartTime}
                        isManualValueChange={isManualValueChange}
                    />
                </div>
            </Fragment>
        );

    }

    render() {
        const {
            isPause,
            audioObjectURL,
            videoObjectURL
        } = this.state
        const { open, isReadyWavesurfer } = this.props

        if (open && (!audioObjectURL || !videoObjectURL || !isReadyWavesurfer)) return <Uploading open={true}></Uploading>

        return (
            <Dialog open={open} maxWidth={"lg"}>
                <div 
                    ref={ref => ref && ref.focus()}
                    className="editvideomusic-dialog-container"
                    tabIndex="0"
                    onKeyDown={this.handleKeyPress}
                >
                        <p className="dialog-title">{i18n.t("makevideo.editvideomusic.title")}</p>

                        {this.renderCropper()}

                        <div className="dialog-controller-container">
                            <img onClick={this.handleClickLeftFrameBtn} src="https://front.videomonster.com/images-u6yd72dy/web/frameMoveLeft.svg" alt={`icon-frame-move-left`}/>
                            <img onClick={this.handleClickPlayAndPauseBtn} src={isPause ? "https://front.videomonster.com/images-u6yd72dy/web/musicPlayBtn.svg" : "https://front.videomonster.com/images-u6yd72dy/web/musicPauseBtn.svg"} alt={`icon-music-play`}/>
                            <img onClick={this.handleClickStopBtn} src="https://front.videomonster.com/images-u6yd72dy/web/musicStopBtn.svg" alt={`icon-music-stop`}/>
                            <img onClick={this.handleClickRightFrameBtn} src="https://front.videomonster.com/images-u6yd72dy/web/frameMoveRight.svg" alt={`icon-frame-move-right`}/>
                        </div>

                        <div className="VMButton-container">
                            <VMButton onClick={this.props.closeDialog} width={'100px'} height={'30px'} style={{ float: 'left' }} >{i18n.t("ImageCropDialog.button.close")}</VMButton>
                            <VMButton onClick={this.onCropComplete} width={'100px'} height={'30px'} color={'secondary'} style={{ float: 'left' }}>{i18n.t("ImageCropDialog.button.complete")}</VMButton>
                        </div>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(EditVideoMusicDialog)